var _style, _path, _g, _g2, _g3, _defs, _rect, _g4, _g5, _g6, _path2, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCassetteDarkRainbow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1294.6 804.4",
    style: {
      enableBackground: "new 0 0 1294.6 804.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A4D5C;}\n\t.st1{fill:#143441;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#91AFCE;}\n\t.st4{fill:#7694AF;}\n\t.st5{clip-path:url(#SVGID_00000165235750055806475220000018161161053466387595_);}\n\t.st6{fill:#A9BECF;}\n\t.st7{fill:#345361;}\n\t.st8{fill:#A2BDD3;}\n\t.st9{fill:#5B6571;}\n\t.st10{fill:#C3DEF0;}\n\t.st11{fill:#F4F5E7;}\n\t.st12{fill:#FF565A;}\n\t.st13{fill:#FFFF5A;}\n\t.st14{fill:#12FF5A;}\n\t.st15{fill:#12FFFF;}\n\t.st16{fill:#FF56FF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1238,0H56.5C35.8,0,18.8,16.9,18.8,37.7v729c0,20.8,16.9,37.7,37.7,37.7H1238c20.8,0,37.7-16.9,37.7-37.7 v-729C1275.7,16.9,1258.8,0,1238,0z M917.5,314.2c27.8,0,50.3,22.5,50.3,50.3c0,27.8-22.5,50.3-50.3,50.3 c-27.8,0-50.3-22.5-50.3-50.3C867.2,336.7,889.7,314.2,917.5,314.2z M377.1,314.2c27.8,0,50.3,22.5,50.3,50.3 c0,27.8-22.5,50.3-50.3,50.3c-27.8,0-50.3-22.5-50.3-50.3C326.8,336.7,349.3,314.2,377.1,314.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1277.7,505.6h-2v201.1h2c9.3,0,16.9-7.5,16.9-16.9V522.5C1294.6,513.2,1287,505.6,1277.7,505.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,505.6h2v201.1h-2c-9.3,0-16.9-7.5-16.9-16.9V522.5C0,513.2,7.5,505.6,16.9,505.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1006.2,615.9H288.3c-10.8,0-20.4,6.9-23.8,17.2l-57.1,171.3h879.8l-57.1-171.3 C1026.6,622.8,1017,615.9,1006.2,615.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M989.8,751c0,15.6-12.7,28.3-28.3,28.3c-15.6,0-28.3-12.7-28.3-28.3c0-15.6,12.7-28.3,28.3-28.3 C977.1,722.7,989.8,735.4,989.8,751z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M860.9,722.7h-50.3c-6.9,0-12.6-5.6-12.6-12.6V685c0-6.9,5.6-12.6,12.6-12.6h50.3c6.9,0,12.6,5.6,12.6,12.6 v25.1C873.5,717.1,867.9,722.7,860.9,722.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.8,751c0,15.6,12.7,28.3,28.3,28.3c15.6,0,28.3-12.7,28.3-28.3c0-15.6-12.7-28.3-28.3-28.3 C317.4,722.7,304.8,735.4,304.8,751z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M433.6,722.7h50.3c6.9,0,12.6-5.6,12.6-12.6V685c0-6.9-5.6-12.6-12.6-12.6h-50.3c-6.9,0-12.6,5.6-12.6,12.6 v25.1C421,717.1,426.7,722.7,433.6,722.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.6,37.7c0,12.1-9.8,22-22,22c-12.1,0-22-9.8-22-22c0-12.1,9.8-22,22-22C68.7,15.7,78.6,25.6,78.6,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45,19.1c-2.9,1.8-5.3,4.2-7.1,7.1l30.2,30.2c2.9-1.8,5.3-4.2,7.1-7.1L45,19.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1238,15.7c-12.1,0-22,9.8-22,22c0,12.1,9.8,22,22,22c12.1,0,22-9.8,22-22C1260,25.6,1250.1,15.7,1238,15.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1256.6,49.3c-1.8,2.9-4.2,5.3-7.1,7.1l-30.2-30.2c1.8-2.9,4.2-5.3,7.1-7.1L1256.6,49.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.6,785.6c12.1,0,22-9.8,22-22c0-12.1-9.8-22-22-22c-12.1,0-22,9.8-22,22 C34.6,775.7,44.4,785.6,56.6,785.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.9,752c1.8-2.9,4.2-5.3,7.1-7.1l30.2,30.2c-1.8,2.9-4.2,5.3-7.1,7.1L37.9,752z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1216,763.6c0-12.1,9.8-22,22-22c12.1,0,22,9.8,22,22c0,12.1-9.8,22-22,22 C1225.8,785.6,1216,775.7,1216,763.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1249.5,782.2c2.9-1.8,5.3-4.2,7.1-7.1l-30.2-30.2c-2.9,1.8-5.3,4.2-7.1,7.1L1249.5,782.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.3,656.7c0-12.1,9.8-22,22-22c12.1,0,22,9.8,22,22c0,12.1-9.8,22-22,22 C635.1,678.7,625.3,668.9,625.3,656.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M658.8,675.4c2.9-1.8,5.3-4.2,7.1-7.1l-30.2-30.2c-2.9,1.8-5.3,4.2-7.1,7.1L658.8,675.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 264.9,
    y: 200.3,
    width: 764.8,
    height: 328.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071536381444861527220000016178328085032793739_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000071536381444861527220000016178328085032793739_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 458.8,
    y: 274,
    className: "st6",
    width: 377.1,
    height: 181
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1019.7,262.3c-56.5-56.4-148-56.4-204.4,0c-56.4,56.4-56.4,148,0,204.4c56.5,56.5,148,56.5,204.4,0 C1076.2,410.3,1076.2,318.7,1019.7,262.3z M917.5,314.2c27.8,0,50.3,22.5,50.3,50.3c0,27.8-22.5,50.3-50.3,50.3 c-27.8,0-50.3-22.5-50.3-50.3C867.2,336.7,889.7,314.2,917.5,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M917.5,238.8c-69.4,0-125.7,56.3-125.7,125.7c0,69.4,56.3,125.7,125.7,125.7 c69.4,0,125.7-56.2,125.7-125.7C1043.2,295.1,986.9,238.8,917.5,238.8z M917.5,414.8c-27.8,0-50.3-22.5-50.3-50.3 c0-27.8,22.5-50.3,50.3-50.3c27.8,0,50.3,22.5,50.3,50.3C967.8,392.3,945.2,414.8,917.5,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M917.5,282.8c-45.1,0-81.7,36.6-81.7,81.7c0,45.1,36.6,81.7,81.7,81.7c45.1,0,81.7-36.6,81.7-81.7 C999.2,319.4,962.6,282.8,917.5,282.8z M917.5,414.8c-27.8,0-50.3-22.5-50.3-50.3c0-27.8,22.5-50.3,50.3-50.3 c27.8,0,50.3,22.5,50.3,50.3C967.8,392.3,945.2,414.8,917.5,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M917.5,298.5c-36.4,0-66,29.5-66,66c0,36.4,29.5,66,66,66c36.4,0,66-29.5,66-66 C983.5,328.1,953.9,298.5,917.5,298.5z M923.8,414.3v-17.5h-12.6v17.5c-13.7-1.7-25.7-9-33.7-19.5l15.1-8.7l-6.3-10.9 l-15.2,8.8c-2.5-6-3.9-12.6-3.9-19.5c0-6.9,1.4-13.5,3.9-19.5l15.2,8.8l6.3-10.9l-15.1-8.7c8-10.5,20-17.8,33.7-19.5v17.5h12.6 v-17.5c13.7,1.7,25.7,9,33.7,19.5l-15.1,8.7l6.3,10.9l15.2-8.8c2.5,6,3.9,12.6,3.9,19.5c0,6.9-1.4,13.5-3.9,19.5l-15.2-8.8 l-6.3,10.9l15.1,8.7C949.5,405.4,937.5,412.6,923.8,414.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M377.1,81.7c-156.2,0-282.8,126.6-282.8,282.8c0,156.2,126.6,282.8,282.8,282.8 c156.2,0,282.8-126.6,282.8-282.8C659.9,208.3,533.2,81.7,377.1,81.7z M377.1,314.2c27.8,0,50.3,22.5,50.3,50.3 c0,27.8-22.5,50.3-50.3,50.3c-27.8,0-50.3-22.5-50.3-50.3C326.8,336.7,349.3,314.2,377.1,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.1,238.8c-69.4,0-125.7,56.3-125.7,125.7c0,69.4,56.2,125.7,125.7,125.7 c69.4,0,125.7-56.2,125.7-125.7C502.8,295.1,446.5,238.8,377.1,238.8z M377.1,414.8c-27.8,0-50.3-22.5-50.3-50.3 c0-27.8,22.5-50.3,50.3-50.3c27.8,0,50.3,22.5,50.3,50.3C427.3,392.3,404.8,414.8,377.1,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M377.1,282.8c-45.1,0-81.7,36.6-81.7,81.7c0,45.1,36.6,81.7,81.7,81.7c45.1,0,81.7-36.6,81.7-81.7 C458.8,319.4,422.2,282.8,377.1,282.8z M377.1,414.8c-27.8,0-50.3-22.5-50.3-50.3c0-27.8,22.5-50.3,50.3-50.3 c27.8,0,50.3,22.5,50.3,50.3C427.3,392.3,404.8,414.8,377.1,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M377.1,298.5c-36.4,0-66,29.5-66,66c0,36.4,29.5,66,66,66c36.4,0,66-29.5,66-66 C443,328.1,413.5,298.5,377.1,298.5z M383.3,414.3v-17.5h-12.6v17.5c-13.7-1.7-25.7-9-33.7-19.5l15.1-8.7l-6.3-10.9l-15.2,8.8 c-2.5-6-3.9-12.6-3.9-19.5c0-6.9,1.4-13.5,3.9-19.5l15.2,8.8l6.3-10.9l-15.1-8.7c8-10.5,20-17.8,33.7-19.5v17.5h12.6v-17.5 c13.7,1.7,25.7,9,33.7,19.5l-15.1,8.7l6.3,10.9l15.2-8.8c2.5,6,3.9,12.6,3.9,19.5c0,6.9-1.4,13.5-3.9,19.5l-15.2-8.8l-6.3,10.9 l15.1,8.7C409.1,405.4,397.1,412.6,383.3,414.3z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.6,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.9,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.7,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 716.4,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.5,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680.3,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.1,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.7,
    y: 345.7,
    className: "st1",
    width: 6.3,
    height: 37.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,100.6v477.6h1156.3V100.6c0-20.8-16.9-37.7-37.7-37.7H106.8C86,62.9,69.1,79.7,69.1,100.6z  M377.1,446.2c-45.1,0-81.7-36.6-81.7-81.7c0-45.1,36.6-81.7,81.7-81.7c45.1,0,81.7,36.6,81.7,81.7 C458.8,409.6,422.2,446.2,377.1,446.2z M804.4,439.9H490.2V289.1h314.2V439.9z M917.5,446.2c-45.1,0-81.7-36.6-81.7-81.7 c0-45.1,36.6-81.7,81.7-81.7c45.1,0,81.7,36.6,81.7,81.7C999.2,409.6,962.6,446.2,917.5,446.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1187.7,75.4H106.8c-13.9,0-25.1,11.3-25.1,25.1v465h1131.2v-465C1212.9,86.7,1201.6,75.4,1187.7,75.4z  M1024.3,458.8H270.2V270.2h754.1V458.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1024.3,
    y: 270.2,
    className: "st12",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.3,
    y: 307.9,
    className: "st13",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.3,
    y: 345.7,
    className: "st14",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.3,
    y: 383.4,
    className: "st15",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.3,
    y: 421.1,
    className: "st16",
    width: 188.5,
    height: 37.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 270.2,
    className: "st12",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 307.9,
    className: "st13",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 345.7,
    className: "st14",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 383.4,
    className: "st15",
    width: 188.5,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 421.1,
    className: "st16",
    width: 188.5,
    height: 37.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 245.1,
    className: "st6",
    width: 1131.2,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 471.3,
    className: "st6",
    width: 1131.2,
    height: 12.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 115.3,
    className: "st0",
    width: 765.1,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 160,
    className: "st0",
    width: 765.1,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 204.8,
    className: "st0",
    width: 765.1,
    height: 6.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.8,518.2c0-1.7,0.3-3.3,1-4.7c0.6-1.5,1.5-2.8,2.6-3.9c1.1-1.1,2.4-2,3.9-2.6c1.5-0.6,3-1,4.7-1h18.6 v8.1h-18.6c-0.6,0-1.1,0.1-1.6,0.3c-0.5,0.2-0.9,0.5-1.3,0.9c-0.4,0.4-0.7,0.8-0.9,1.3c-0.2,0.5-0.3,1-0.3,1.6 c0,0.6,0.1,1.1,0.3,1.6c0.2,0.5,0.5,0.9,0.9,1.3c0.4,0.4,0.8,0.7,1.3,0.9c0.5,0.2,1,0.3,1.6,0.3h8.1c1.7,0,3.3,0.3,4.7,0.9 c1.5,0.6,2.8,1.5,3.9,2.6c1.1,1.1,2,2.4,2.6,3.9c0.6,1.5,0.9,3.1,0.9,4.7c0,1.7-0.3,3.3-0.9,4.7c-0.6,1.5-1.5,2.8-2.6,3.9 c-1.1,1.1-2.4,2-3.9,2.6c-1.5,0.6-3.1,1-4.7,1h-18v-8.1h18c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.9-0.5,1.3-0.9 c0.4-0.4,0.7-0.8,0.9-1.3c0.2-0.5,0.3-1,0.3-1.6c0-0.6-0.1-1.1-0.3-1.6c-0.2-0.5-0.5-0.9-0.9-1.3c-0.4-0.4-0.8-0.7-1.3-0.9 c-0.5-0.2-1-0.3-1.6-0.3h-8.1c-1.7,0-3.3-0.3-4.7-1c-1.5-0.6-2.8-1.5-3.9-2.6c-1.1-1.1-2-2.4-2.6-3.9 C159.1,521.5,158.8,519.9,158.8,518.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 506,
    className: "st0",
    width: 8.1,
    height: 40.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.7,526.3c0,1.9-0.2,3.7-0.7,5.4c-0.5,1.7-1.2,3.3-2,4.8c-0.9,1.5-1.9,2.9-3.2,4.1 c-1.2,1.2-2.6,2.3-4.1,3.2c-1.5,0.9-3.1,1.6-4.8,2.1c-1.7,0.5-3.5,0.7-5.4,0.7h-12.2V506h12.2c1.9,0,3.7,0.2,5.4,0.7 c1.7,0.5,3.3,1.2,4.8,2c1.5,0.9,2.9,2,4.1,3.2c1.2,1.2,2.3,2.6,3.2,4.1c0.9,1.5,1.6,3.1,2,4.8 C244.4,522.7,244.7,524.5,244.7,526.3z M236.6,526.3c0-1.7-0.3-3.3-0.9-4.7c-0.6-1.5-1.5-2.8-2.6-3.9c-1.1-1.1-2.4-2-3.9-2.6 c-1.5-0.6-3.1-1-4.7-1h-4v24.3h4c1.7,0,3.3-0.3,4.7-0.9c1.5-0.6,2.8-1.5,3.9-2.6c1.1-1.1,2-2.4,2.6-3.9 C236.2,529.6,236.6,528,236.6,526.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "277.8,546.6 250,546.6 250,506 277.8,506 277.8,514.2 258.2,514.2 258.2,522.3 271.5,522.3  271.5,530.4 258.2,530.4 258.2,538.5 277.8,538.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "310.3,546.6 302.2,546.6 302.2,514.2 298.2,514.2 298.2,506 310.3,506  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M883,516.7c0-1.7,0.3-3.3,1-4.7c0.6-1.5,1.5-2.8,2.6-3.9c1.1-1.1,2.4-2,3.9-2.6c1.5-0.6,3-1,4.7-1h18.6v8.1 h-18.6c-0.6,0-1.1,0.1-1.6,0.3c-0.5,0.2-0.9,0.5-1.3,0.9c-0.4,0.4-0.7,0.8-0.9,1.3c-0.2,0.5-0.3,1-0.3,1.6c0,0.6,0.1,1.1,0.3,1.6 c0.2,0.5,0.5,0.9,0.9,1.3c0.4,0.4,0.8,0.7,1.3,0.9c0.5,0.2,1,0.3,1.6,0.3h8.1c1.7,0,3.3,0.3,4.7,0.9c1.5,0.6,2.8,1.5,3.9,2.6 c1.1,1.1,2,2.4,2.6,3.9c0.6,1.5,0.9,3.1,0.9,4.7c0,1.7-0.3,3.3-0.9,4.7c-0.6,1.5-1.5,2.8-2.6,3.9c-1.1,1.1-2.4,2-3.9,2.6 c-1.5,0.6-3.1,1-4.7,1h-18V537h18c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.9-0.5,1.3-0.9c0.4-0.4,0.7-0.8,0.9-1.3c0.2-0.5,0.3-1,0.3-1.6 c0-0.6-0.1-1.1-0.3-1.6c-0.2-0.5-0.5-0.9-0.9-1.3c-0.4-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1-0.3-1.6-0.3h-8.1c-1.7,0-3.3-0.3-4.7-1 c-1.5-0.6-2.8-1.5-3.9-2.6c-1.1-1.1-2-2.4-2.6-3.9C883.4,520,883,518.4,883,516.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "937.3,545.1 929.2,545.1 929.2,512.7 917,512.7 917,504.5 949.4,504.5 949.4,512.7 937.3,512.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "981.5,545.1 953.7,545.1 953.7,504.5 981.5,504.5 981.5,512.7 961.8,512.7 961.8,520.8 975.2,520.8  975.2,528.9 961.8,528.9 961.8,537 981.5,537  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M995.3,545.1h-8.1v-40.6h16.2c1.5,0,2.9,0.2,4.3,0.6c1.4,0.4,2.7,0.9,3.9,1.6c1.2,0.7,2.3,1.6,3.3,2.5 c1,1,1.8,2.1,2.5,3.3c0.7,1.2,1.3,2.5,1.6,3.9c0.4,1.4,0.6,2.8,0.6,4.3c0,1.4-0.2,2.8-0.5,4.1c-0.3,1.3-0.8,2.6-1.5,3.8 c-0.7,1.2-1.4,2.3-2.4,3.3c-0.9,1-2,1.9-3.2,2.6l4.5,10.6h-8.6l-3.5-8.2l-9.1,0.1V545.1z M995.3,512.7v16.2h8.1 c1.1,0,2.2-0.2,3.1-0.6c1-0.4,1.8-1,2.6-1.7c0.7-0.7,1.3-1.6,1.7-2.6c0.4-1,0.6-2,0.6-3.2c0-1.1-0.2-2.2-0.6-3.2 c-0.4-1-1-1.8-1.7-2.6c-0.7-0.7-1.6-1.3-2.6-1.7c-1-0.4-2-0.6-3.1-0.6H995.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1052.8,545.1 1025,545.1 1025,504.5 1052.8,504.5 1052.8,512.7 1033.1,512.7 1033.1,520.8  1046.4,520.8 1046.4,528.9 1033.1,528.9 1033.1,537 1052.8,537  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1097.2,525c0,1.9-0.3,3.8-0.8,5.6c-0.5,1.8-1.2,3.4-2.1,5c-0.9,1.6-2,3-3.3,4.3c-1.3,1.3-2.7,2.4-4.2,3.3 c-1.5,0.9-3.2,1.6-5,2.1c-1.8,0.5-3.7,0.8-5.6,0.8c-1.9,0-3.8-0.3-5.6-0.8c-1.8-0.5-3.4-1.2-5-2.1c-1.6-0.9-3-2-4.3-3.3 c-1.3-1.3-2.4-2.7-3.3-4.3c-0.9-1.6-1.6-3.2-2.1-5c-0.5-1.8-0.8-3.6-0.8-5.6c0-1.9,0.3-3.8,0.8-5.6c0.5-1.8,1.2-3.5,2.1-5 c0.9-1.5,2-3,3.3-4.2c1.3-1.3,2.7-2.4,4.3-3.3c1.6-0.9,3.2-1.6,5-2.1c1.8-0.5,3.6-0.7,5.6-0.7c1.9,0,3.8,0.3,5.6,0.7 c1.8,0.5,3.5,1.2,5,2.1c1.5,0.9,3,2,4.2,3.3c1.3,1.3,2.4,2.7,3.3,4.2c0.9,1.5,1.6,3.2,2.1,5C1097,521.2,1097.2,523.1,1097.2,525z  M1089.1,525c0-1.8-0.3-3.4-1-5c-0.7-1.6-1.6-2.9-2.8-4.1c-1.2-1.2-2.5-2.1-4.1-2.8c-1.6-0.7-3.2-1-5-1c-1.8,0-3.5,0.3-5,1 c-1.6,0.7-2.9,1.6-4.1,2.8c-1.2,1.2-2.1,2.5-2.8,4.1c-0.7,1.6-1,3.2-1,5c0,1.8,0.3,3.4,1,5c0.7,1.6,1.6,2.9,2.8,4.1 c1.2,1.2,2.5,2.1,4.1,2.8c1.6,0.7,3.2,1,5,1c1.8,0,3.4-0.3,5-1c1.6-0.7,2.9-1.6,4.1-2.8c1.2-1.2,2.1-2.5,2.8-4.1 C1088.8,528.4,1089.1,526.8,1089.1,525z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.9,152.9c0,5.6-0.6,11.2-1.7,16.5c-1.1,5.4-2.8,10.5-4.9,15.2c-2.1,4.8-4.7,9.2-7.8,13.3 c-3.1,4.1-6.5,7.6-10.4,10.6h-23.8c2.5-1.6,4.9-3.4,7.2-5.3c2.3-2,4.6-4.1,6.7-6.3c2.1-2.2,4.1-4.6,5.9-7.1 c1.8-2.5,3.4-5.1,4.8-7.7c-1.8,1.2-3.7,2.2-5.8,3c-2,0.8-4.2,1.3-6.3,1.3c-5,0-9.5-0.8-13.4-2.5c-4-1.7-7.4-4-10.2-6.9 c-2.8-3-5-6.5-6.4-10.6c-1.5-4.1-2.2-8.6-2.2-13.4c0-4.7,0.8-9.2,2.5-13.5c1.7-4.2,4-7.9,7-11.1c3-3.2,6.5-5.7,10.6-7.5 c4.1-1.8,8.5-2.8,13.3-2.8c4.8,0,9.4,0.9,13.6,2.8c4.2,1.8,7.9,4.3,11.1,7.5c3.2,3.2,5.6,6.9,7.5,11.1 C209,143.7,209.9,148.2,209.9,152.9z M191.1,152.9c0-2.2-0.4-4.4-1.2-6.5c-0.8-2.1-1.9-3.9-3.3-5.5c-1.4-1.6-3.1-2.9-5.1-3.8 c-2-0.9-4.1-1.4-6.5-1.4c-2.4,0-4.6,0.5-6.5,1.4c-1.9,0.9-3.6,2.2-5,3.7c-1.4,1.6-2.5,3.4-3.2,5.5c-0.7,2.1-1.1,4.3-1.1,6.7 c0,2.3,0.4,4.5,1.1,6.6c0.7,2.1,1.8,3.9,3.2,5.4c1.4,1.6,3.1,2.8,5,3.7c1.9,0.9,4.1,1.3,6.5,1.3c2.4,0,4.6-0.4,6.6-1.3 c2-0.9,3.7-2.1,5.1-3.7c1.4-1.6,2.5-3.4,3.2-5.4C190.7,157.5,191.1,155.3,191.1,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,165c0,4.2-0.5,8.2-1.6,12.1c-1.1,3.9-2.6,7.5-4.6,10.9c-2,3.4-4.3,6.5-7.1,9.2 c-2.8,2.8-5.8,5.2-9.2,7.2c-3.4,2-7,3.5-10.9,4.6c-3.9,1.1-7.9,1.6-12.1,1.6c-4.2,0-8.2-0.5-12.1-1.6c-3.9-1.1-7.5-2.6-10.9-4.6 c-3.4-2-6.5-4.4-9.2-7.2c-2.8-2.8-5.2-5.9-7.2-9.2c-2-3.4-3.5-7-4.6-10.9c-1.1-3.9-1.6-7.9-1.6-12.1c0-4.2,0.5-8.2,1.6-12.1 c1.1-3.9,2.6-7.5,4.6-10.9c2-3.4,4.4-6.4,7.2-9.2c2.8-2.8,5.9-5.2,9.2-7.1c3.4-2,7-3.5,10.9-4.6c3.9-1.1,7.9-1.6,12.1-1.6 c4.2,0,8.2,0.5,12.1,1.6c3.9,1.1,7.5,2.6,10.9,4.6c3.4,2,6.4,4.3,9.2,7.1c2.8,2.8,5.2,5.8,7.1,9.2c2,3.4,3.5,7,4.6,10.9 C308.5,156.8,309.1,160.8,309.1,165z M291.6,165c0-3.8-0.7-7.5-2.2-10.9c-1.5-3.4-3.5-6.4-6-8.9c-2.5-2.5-5.5-4.5-8.9-6 c-3.4-1.5-7-2.2-10.9-2.2c-3.9,0-7.5,0.7-10.9,2.2c-3.4,1.5-6.4,3.5-8.9,6c-2.5,2.5-4.5,5.5-6,8.9c-1.5,3.4-2.2,7-2.2,10.9 c0,3.8,0.7,7.5,2.2,10.8c1.5,3.4,3.5,6.3,6,8.9c2.5,2.5,5.5,4.5,8.9,6c3.4,1.5,7,2.2,10.9,2.2c3.8,0,7.5-0.7,10.9-2.2 c3.4-1.5,6.4-3.5,8.9-6c2.5-2.5,4.5-5.5,6-8.9C290.8,172.4,291.6,168.8,291.6,165z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCassetteDarkRainbow);
export default __webpack_public_path__ + "static/media/cassette-dark-rainbow.f7a198abf3f09ffa781e818d98f66062.svg";
export { ForwardRef as ReactComponent };